// scheduling/components/idd/IDDBulkBar.jsx
// Shown while rows are ticked. The main button applies each row's own recommendation; its
// tooltip (and the confirm) gives the mix. The single actions follow as small links; the
// rows they don't fit are skipped, and the confirm says so. Ticked rows already decided
// can be undone together (primary is null when only those are ticked).

export default function IDDBulkBar({ selectedCount, primary, others = [], undo, onClear, busy }) {
  if (!selectedCount) return null;
  return (
    <div className="idd-bulkbar" role="region" aria-label="Selected jobs">
      <span className="idd-bulkbar-count"><strong>{selectedCount}</strong> selected</span>
      {primary && (
        <button
          className={`idd-dec-btn idd-dec-btn--${primary.tone || 'budget'} idd-dec-btn--primary`}
          disabled={busy || primary.count === 0}
          onClick={primary.onClick}
          title={primary.title}
        >
          {primary.label}
        </button>
      )}
      {others.length > 0 && <span className="idd-bulkbar-or">or</span>}
      {others.map(a => (
        <button key={a.key} className="idd-bulkbar-alt" disabled={busy || a.count === 0} onClick={a.onClick} title={a.title}>
          {a.label}
        </button>
      ))}
      {undo && (
        <button className="idd-bulkbar-undo" disabled={busy} onClick={undo.onClick} title={undo.title}>{undo.label}</button>
      )}
      <button className="idd-bulkbar-clear" onClick={onClear} disabled={busy}>Clear selection</button>
      {busy && <span className="idd-bulkbar-busy">{busy}</span>}
    </div>
  );
}
